import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../components/layout/AuthContext';
const PrivateRoutes = () => {
    const { state } = useAuth();
    return(
        state.isAuthenticated ? <Outlet/> : <Navigate to="/home"/>
    )
}

export default PrivateRoutes